<div class="help-admin-page">
    <!-- Editor Overlay -->
    <div *ngIf="showEditor" class="editor-overlay">
        <mvs-article-editor
            [moduleAlias]="moduleAlias"
            [articleId]="editingArticleId"
            (saved)="onArticleSaved($event)"
            (cancelled)="onEditorCancelled()">
        </mvs-article-editor>
    </div>

    <!-- Admin Content -->
    <div *ngIf="!showEditor">
        <div class="admin-header">
            <h1>Dokumentation verwalten</h1>
            <div class="header-actions">
                <mvs-help-search [moduleAlias]="moduleAlias"></mvs-help-search>
                <button pButton
                        icon="pi pi-plus"
                        label="Neuer Artikel"
                        (click)="onNewArticle()">
                </button>
            </div>
        </div>

        <!-- Tab Navigation -->
        <p-tabs [(value)]="activeTabIndex">
            <p-tablist>
                <p-tab [value]="0">Artikel</p-tab>
                <p-tab [value]="1">Kategorien</p-tab>
                <p-tab [value]="2">Glossar</p-tab>
            </p-tablist>

            <p-tabpanels>
                <!-- Articles Tab -->
                <p-tabpanel [value]="0">
                    <div *ngIf="isLoading" class="loading">
                        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem;"></i>
                    </div>

                    <div *ngIf="!isLoading" class="articles-list">
                        <p-table [value]="articles" [rows]="20" [paginator]="articles.length > 20" styleClass="p-datatable-sm">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Titel</th>
                                    <th style="width: 120px;">Status</th>
                                    <th style="width: 100px;">Aufrufe</th>
                                    <th style="width: 130px;">Aktualisiert</th>
                                    <th style="width: 150px;">Aktionen</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-article>
                                <tr>
                                    <td>
                                        <div class="article-title-cell">
                                            <span class="article-title">{{article.title}}</span>
                                            <span *ngIf="article.categoryName" class="article-category">{{article.categoryName}}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <p-tag [value]="getStatusLabel(article.status)"
                                               [severity]="getStatusSeverity(article.status)">
                                        </p-tag>
                                    </td>
                                    <td>{{article.viewCount}}</td>
                                    <td>{{article.lastModifiedDate | date:'dd.MM.yyyy'}}</td>
                                    <td>
                                        <div class="action-buttons">
                                            <button pButton
                                                    icon="pi pi-pencil"
                                                    class="p-button-text p-button-sm"
                                                    pTooltip="Bearbeiten"
                                                    (click)="onEditArticle(article)">
                                            </button>
                                            <button pButton
                                                    *ngIf="article.status !== 2"
                                                    icon="pi pi-check"
                                                    class="p-button-text p-button-success p-button-sm"
                                                    pTooltip="Veroeffentlichen"
                                                    (click)="onPublishArticle(article)">
                                            </button>
                                            <button pButton
                                                    *ngIf="article.status === 2"
                                                    icon="pi pi-ban"
                                                    class="p-button-text p-button-warning p-button-sm"
                                                    pTooltip="Archivieren"
                                                    (click)="onChangeStatus(article, 'ARCHIVED')">
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5" class="text-center">Keine Artikel vorhanden.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-tabpanel>

                <!-- Categories Tab -->
                <p-tabpanel [value]="1">
                    <div class="categories-tree">
                        <p *ngIf="categories.length === 0">Keine Kategorien vorhanden.</p>
                        <div *ngFor="let cat of categories" class="category-item">
                            <i class="pi" [class]="cat.iconClass || 'pi-folder'"></i>
                            <span>{{cat.name}}</span>
                            <span *ngIf="cat.description" class="category-desc">- {{cat.description}}</span>
                        </div>
                    </div>
                </p-tabpanel>

                <!-- Glossary Tab -->
                <p-tabpanel [value]="2">
                    <mvs-glossary-panel [moduleAlias]="moduleAlias"></mvs-glossary-panel>
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>
    </div>
</div>
